import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop, scroll the window to (0,0) on every route change.
 * Honours hash navigation (e.g. /about#press) by scrolling to the element instead.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
